var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from "react";
import { Row } from "reactstrap";
import { Button, useLinkResolver } from "../../../components";
import arvalIcon from "../../../assets/icons/logos/arval.png";
import { LogosArvalContainer, LogosArvalCol, LogosArvalText, LogosArvalImg } from "./LogosArval.styled";

var LogosArval = function LogosArval(_a) {
  var link = _a.link,
      anchor = _a.anchor,
      props = __rest(_a, ["link", "anchor"]);

  var resolveAction = useLinkResolver().resolveAction;
  return React.createElement(LogosArvalContainer, __assign({
    id: anchor,
    fluid: true
  }, props), React.createElement(Row, null, React.createElement(LogosArvalCol, null, React.createElement(Button, {
    hasArrow: true,
    onClick: function onClick() {
      return resolveAction(link);
    }
  }, "Sprawd\u017A ofert\u0119"), React.createElement(LogosArvalText, null, "Zostaniesz przekierowany na stron\u0119 BNP Paribas"), React.createElement(LogosArvalImg, {
    src: arvalIcon,
    alt: ""
  }))));
};

export default LogosArval;